import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { MARK } from '../../../constants';
import { situacaoDaPrenha } from '../../../utils/calculations/prenhas';

/**
 * As receptoras prenhas, um grupo por cliente: a mesma peça no relatório e no
 * assistente, para os dois não divergirem.
 *
 * Os grupos abrem fechados, como os do Financeiro. Só com um cliente na lista
 * ele já vem aberto: foi dele que se perguntou.
 *
 * Cada grupo é uma tabela, então a largura é fixa: com largura automática as
 * colunas mudariam de lugar de um cliente para o outro.
 */
export const dataBR = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—');

const th = 'px-2 py-1.5 text-left text-xs font-semibold text-slate-500';

const PrenhasPorCliente = ({ grupos = [] }) => {
  const [aberto, setAberto] = useState(grupos.length === 1 ? grupos[0].chave : null);

  return (
    <div className="bg-white border border-slate-200 rounded-xl divide-y divide-slate-100 overflow-hidden">
      {grupos.map(g => {
        const expandido = aberto === g.chave;
        return (
          <div key={g.chave}>
            <button type="button" onClick={() => setAberto(expandido ? null : g.chave)}
              aria-expanded={expandido}
              className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-slate-50">
              <ChevronRight className={`w-4 h-4 shrink-0 text-slate-400 transition-transform ${expandido ? 'rotate-90' : ''}`} />
              <span className="flex-1 min-w-0 text-sm font-medium text-slate-900 truncate">{g.client_name}</span>
              <span className="text-sm text-slate-600 whitespace-nowrap">
                {g.prenhas.length} prenha{g.prenhas.length > 1 ? 's' : ''}
                <span className="hidden sm:inline text-slate-500">
                  {' · '}{g.confirmadas} confirmada{g.confirmadas === 1 ? '' : 's'}
                  {g.proximo_parto ? ` · próximo parto ${dataBR(g.proximo_parto)}` : ''}
                </span>
              </span>
            </button>

            {expandido && (
              <div className="overflow-x-auto border-t border-slate-100">
                <table className="w-full min-w-[52rem] table-fixed text-sm break-words">
                  <colgroup>
                    <col className="w-28" />
                    <col />
                    <col />
                    <col className="w-20" />
                    <col className="w-28" />
                    <col className="w-28" />
                    <col className="w-40" />
                    <col className="w-24" />
                  </colgroup>
                  <thead className="bg-slate-50">
                    <tr>
                      <th className={`${th} pl-4`}>Receptora</th>
                      <th className={th}>Doadora</th>
                      <th className={th}>Touro</th>
                      <th className={th}>Sexo</th>
                      <th className={th}>TE</th>
                      <th className={th}>Parto previsto</th>
                      <th className={th}>Situação</th>
                      <th className={th}>Serviço</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {g.prenhas.map(p => (
                      <tr key={p.chave} className="hover:bg-slate-50">
                        <td className="px-2 py-1.5 pl-4 font-medium text-slate-900">{p.recipient_identifier || '—'}</td>
                        <td className="px-2 py-1.5 text-slate-700">{p.doadora || '—'}</td>
                        <td className="px-2 py-1.5 text-slate-700">{p.touro || '—'}</td>
                        <td className="px-2 py-1.5 text-slate-600">{p.fetus_sex || '—'}</td>
                        <td className="px-2 py-1.5 text-slate-600">{dataBR(p.te_date)}</td>
                        <td className="px-2 py-1.5 font-medium text-slate-900">{dataBR(p.parto_previsto)}</td>
                        <td className="px-2 py-1.5 text-slate-600">{situacaoDaPrenha(p, MARK)}</td>
                        <td className="px-2 py-1.5 text-xs text-slate-500">{p.service_code || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PrenhasPorCliente;
